<fieldset class="fieldGroup">
  <legend>Rating Input Criteria</legend>
  <div class="ratingsInputPanel">
    <div class="detailRow">
      <label class="displayLabel">Airflow:</label>
      <label class="displayValue">{{ ratingRequest().Airflow }}</label>
      <label class="configurationRatingUnitLabel">{{ getAirflowUnits() }}</label>
      <label class="displayLabel">Altitude:</label>
      <label class="displayValue">{{ ratingRequest().Altitude }}</label>
      <label class="configurationRatingUnitLabel">{{ getAltitudeUnits() }}</label>
    </div>
    <div class="detailRow">
      <label class="displayLabel">ESP:</label>
      <label class="displayValue">{{ ratingRequest().ExternalStaticPressure }}</label>
      <label class="configurationRatingUnitLabel">{{ getEspUnits() }}</label>
      @if (ratingRequest().Filter) {
        <span>
          <label class="displayLabel">Filter:</label>
          <label class="displayValue">{{ ratingRequest().Filter }}</label>
        </span>
      }
      @if (ratingRequest().FanSpeed) {
        <span>
          <label class="displayLabel">Fan Speed:</label>
          <label class="displayValue">{{ ratingRequest().FanSpeed }}</label>
        </span>
      }
    </div>
    <div>
      @if (ratingRequest()?.PrimaryCoilRequest) {
        <div class="ratingsInputPanel">
          <app-coil-request [title]="'Primary Criteria'" [coilRequest]="ratingRequest().PrimaryCoilRequest"
            [metricInput]="metricInput()">
          </app-coil-request>
        </div>
      }
      @if (ratingRequest()?.SecondaryCoilRequest || ratingRequest()?.ElectricHeatRequest) {
        <div class="ratingsInputPanel">
          @if (ratingRequest()?.SecondaryCoilRequest) {
            <div>
              <app-coil-request [title]="'Secondary Criteria'" [coilRequest]="ratingRequest().SecondaryCoilRequest"
                [metricInput]="metricInput()">
              </app-coil-request>
            </div>
          }
          @if (ratingRequest()?.ElectricHeatRequest) {
            <div>
              <app-coil-request [title]="'E-Heat Criteria'" [coilRequest]="ratingRequest().ElectricHeatRequest"
                [metricInput]="metricInput()">
              </app-coil-request>
            </div>
          }
        </div>
      }
    </div>
  </div>
</fieldset>
